import { Button, Col, Row } from "antd";
import React from "react";

const QuestionItem = ({ summaryHandler, question }) => {
  return (
    question &&
    <Col span={24} className="question-container mt-20 mb-0">
      <p className="text-left mr-10 ml-10 mb-0">
        {question.title}
      </p>
      <Row className="mt-20 mr-10 ml-10 mb-0" justify="center">
        <Col span={12} className="text-left">
          <p><strong>{
            (() => {
              if (!question?.selected_option) return '';
              if (Array.isArray(question.selected_option)) {
                return question.selected_option.map(selectedOption => selectedOption.text || selectedOption.value).join(', ');
              }
              return question.type !== 'select' && question.type !== 'select_multiple' 
                ? question.selected_option.value 
                : (question.selected_option.text || question.selected_option.value);
            })()
          }</strong></p>
        </Col>
        <Col span={12} className="text-right">
          <Button
            type="text"
            onClick={() => summaryHandler.setQuestionToEdit(question)}
            className="cmt-button non-outline summary-edit-button p-0 m-0"
            size="small"
          >
            EDITAR
          </Button>
        </Col>
      </Row>
    </Col>
  )
}

export default QuestionItem;